<form #form="ngForm" (ngSubmit)="save(form)">
  <div class="p-fluid p-grid p-mt-2">
      <div class="p-field p-col-12 p-md-12" style="height:240px;">
        <p-table [value]="userList" 
                [(selection)]="selectedUsers" 
                [scrollable]="true" 
                styleClass="p-datatable-gridlines p-datatable-striped"
                selectionMode="multiple"
                scrollHeight="200px"
                dataKey="id">
          <ng-template pTemplate="header">
              <tr class="table-header">
                <th style="width: 3rem;">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>User List</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-emp let-rowIndex="rowIndex">
              <tr [pSelectableRow]="emp"  [pSelectableRowIndex]="rowIndex">
                  <td style="width: 3rem">
                      <p-tableCheckbox [value]="emp" (click)="$event.stopPropagation()"></p-tableCheckbox>
                  </td>
                  <td>{{getFullname(emp)}}</td>
              </tr>
          </ng-template>
        </p-table>
      </div>
  </div>

  <div class="modal-footer">
    <button pButton pRipple label="Assign" class="p-button" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Cancel" class="p-button p-button-outlined" icon="pi pi-times" type="button" (click)="cancel()"></button>
  </div>
</form>
